import React from "react";

import { ScrollablePane, ScrollbarVisibility, Stack } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import {
  FieldDevice,
  TenantDeploymentRingGetArgs,
  TenantDeploymentRingSummary
} from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useTenantDeploymentRings } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { DeviceTenantDeploymentRingTable } from "./DeviceTenantDeploymentRingTable";

interface DeviceTenantDeploymentRingListProps {
  device: FieldDevice;
}

export const DeviceTenantDeploymentRingList: React.FC<DeviceTenantDeploymentRingListProps> = ({
  device
}) => {
  const sortBySortOrder = (
    fieldDeviceDeploymentRingDetails: TenantDeploymentRingSummary[]
  ) =>
    fieldDeviceDeploymentRingDetails.sort((a, b) => a.sortOrder - b.sortOrder);

  const query = useTenantDeploymentRings({
    fieldDeviceId: device.id
  } as TenantDeploymentRingGetArgs);

  return (
    <QueryStateIndicator<TenantDeploymentRingSummary[]>
      allowNullOrUndefined
      {...query}
    >
      {fieldDeviceDeploymentRings => (
        <Stack grow styles={{ root: { position: "relative" } }} verticalFill>
          <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
            <DeviceTenantDeploymentRingTable
              items={sortBySortOrder(fieldDeviceDeploymentRings)}
              device={device}
            />
          </ScrollablePane>
        </Stack>
      )}
    </QueryStateIndicator>
  );
};
